module.exports = __webpack_public_path__ + "img/main1.98320052.png";